// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + ({"3":"wec.app","93":"wec-icon-6","100":"wec-icon-3","224":"wec-icon-1","318":"wec-icon-2","521":"wec-icon-11","602":"wec-icon-0","659":"wec-icon-9","713":"wec-icon-7","752":"wec-icon-10","784":"wec-icon-5","869":"wec-icon-4","963":"wec-icon-8"}[chunkId] || chunkId) + ".css";
};